var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', [_c('strong', [_vm._v("КАПУСТА")]), _c('br'), _vm._v(" space ")])]);
}]

export { render, staticRenderFns }